var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataTable',{ref:"datatable",attrs:{"url":_vm.api.ACTIONS.REGISTRATION_REQUESTS,"initial-url-search-params":_vm.params,"enable-add":false,"enable-edit":false,"enable-delete":false,"fields-hidden-main":['verified', 'provider']}})
}
var staticRenderFns = []

export { render, staticRenderFns }